import { Tab, Tabs } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { FunctionComponent } from "react";
import cs from "classnames";

export interface ProtocolPaginationViewProps {
  total: number;
  currentPage: number;
  perPage: number;
  totalElements: number;
  setCurrentPage: (page: number) => void;
  className?: string;
}

export const ProtocolPaginationView: FunctionComponent<
  ProtocolPaginationViewProps
> = ({
  total,
  currentPage,
  perPage,
  totalElements,
  setCurrentPage,
  className,
}) => {
  const classes = useStyles();

  if (total < 2) return null;

  return (
    <Tabs
      className={cs(classes.container, className)}
      textColor="secondary"
      value={currentPage}
      indicatorColor="secondary"
      scrollButtons="auto"
      variant="scrollable"
      allowScrollButtonsMobile
      onChange={(_, value) => {
        setCurrentPage(value);
      }}
    >
      {Array(total)
        .fill(0)
        .map((_, index) => {
          const startInterval = index * perPage + 1;
          const maxPages = (index + 1) * perPage;
          const endInterval =
            maxPages > totalElements ? totalElements : maxPages;
          return (
            <Tab
              value={index}
              key={index}
              label={`${startInterval} - ${endInterval}`}
            />
          );
        })}
    </Tabs>
  );
};

const useStyles = makeStyles({
  container: { margin: "1rem 0" },
});
